/** @file Curve-graph view state (vanilla zustand): axes, normalize, gesture, active key, pinned refs. */
import { createStore } from 'zustand/vanilla';
import type { KeyRef } from '../../stores/types';
import type { CurveActiveKey, CurveAxes, CurveGesture, CurveRef } from './curveTypes';

/** Per-editor view of the Curves tab; read imperatively by the paint loop, never copied into React state. */
export interface CurveViewState extends CurveAxes {
  normalized: boolean;
  /** False until the first frame-all after tracks appear (and again after frame-all is asked for). */
  fitted: boolean;
  gesture: CurveGesture;
  /** The last key clicked in the graph (the shape source) by timeline and frame, or null; see activeCurveKey. */
  active: CurveActiveKey | null;
  /** Refs kept on screen while the graph itself rewrites the key selection. */
  pinned: CurveRef[];
  /** The keys array the graph last wrote to the selection store (by identity), to tell its writes apart. */
  ownKeys: KeyRef[] | null;
}

/** One store per editor page; `loadProject` does not reset it (axes survive a project switch until frame-all). */
export const curveViewStore = createStore<CurveViewState>()(() => ({
  time: { frame0: -2, pxPerFrame: 12 },
  value: { top: 1.2, pxPerUnit: 200 },
  normalized: false,
  fitted: false,
  gesture: { kind: 'idle' },
  active: null,
  pinned: [],
  ownKeys: null,
}));
